/**
 * Configuração do pin no mapa.
 * Altere latitude e longitude para o endereço desejado.
 * Dica: no Google Maps, clique com o botão direito no local e copie as coordenadas.
 */
export const mapLocation = {
  latitude: -22.967071,
  longitude: -43.186456,
  zoom: 16,
  /** Nome do local (opcional, para acessibilidade) */
  label: 'Consultório',
  /**
   * Place ID do Google Maps para exibir o card de detalhes no canto do mapa.
   * Exemplo de formato: ChIJxxxxxxxxxxxxxxxxxxxxxx
   */
  placeId: '',
} as const;
